import { useEffect, useState, type ReactNode } from "react";
import { useNavigate } from "react-router";

interface GuestGuardProps {
  readonly children: ReactNode;
}

export function GuestGuard({ children }: GuestGuardProps) {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    fetch("/api/auth/me")
      .then(async (res) => {
        if (res.ok) {
          const data = await res.json();
          const membership = data.data?.membership;
          if (membership?.isAccountCreator && !membership?.onboardingCompleted) {
            navigate("/onboarding", { replace: true });
          } else {
            navigate("/dashboard", { replace: true });
          }
        } else {
          setReady(true);
        }
      })
      .catch(() => {
        setReady(true);
      });
  }, [navigate]);

  if (!ready) return null;

  return <>{children}</>;
}
